module.exports = __webpack_public_path__ + "img/seq13.53054036.png";